import { HTTPStatus } from '@cambridgeassessment/lib-ee-commons';
export const isTokenInvalid = (res) => {
    if (res.ok) {
        return false;
    }
    return res.status === HTTPStatus.UNAUTHORIZED;
};
export const getTokenKey = () => {
    const sessionStorageKeys = Object.keys(window.sessionStorage);
    const userTokenStorageKey = sessionStorageKeys.filter((key) => key.startsWith('oidc.user:'))[0];
    return userTokenStorageKey;
};
export const clearToken = () => {
    const sessionStorageKey = getTokenKey();
    window.sessionStorage.removeItem(sessionStorageKey);
};
export const parseUserData = () => {
    const userTokenStorageKey = getTokenKey();
    const oidcUser = window.sessionStorage.getItem(userTokenStorageKey);
    return JSON.parse(oidcUser);
};
export const handleTokenExpiration = () => {
    sessionStorage.removeItem(getTokenKey());
    window.location.reload();
};
export const getUserProfile = () => {
    const { profile } = parseUserData();
    return profile;
};
export const getToken = () => {
    try {
        const { access_token } = parseUserData();
        return access_token;
    }
    catch (_a) {
        return null;
    }
};
